import React from "react";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";

import Sidebar from "../components/layout/Sidebar";
import Topbar from "../components/layout/Topbar";

export default function MainLayout() {
  return (
    <div className="page app-shell">
      <Sidebar />
      <div className="page-wrapper">
        <Topbar />
        <div className="page-body">
          <Container fluid="lg">
            <Outlet />
          </Container>
        </div>
      </div>
    </div>
  );
}

